const MAX_BYTES = 4 * 1024 * 1024;

/** Read a local image file as a data URL (base64). */
export function readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
        if (!file?.type?.startsWith("image/")) {
            reject(new Error("Only image files are allowed"));
            return;
        }
        if (file.size > MAX_BYTES) {
            reject(new Error("Image must be 4 MB or smaller"));
            return;
        }
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error || new Error("Failed to read file"));
        reader.readAsDataURL(file);
    });
}
